<template>
  <div class="html-viewer" v-html="html"></div>
</template>
<script>
export default {
  name: 'HtmlViewer',
  props: {
    html: {
      type: String,
      required: true,
    },
  },
}
</script>
<style lang="stylus">
.html-viewer
    table {
      width: 100%;
      margin: 20px auto;
      table-layout: fixed;
    }
    table,
    td,
    th {
      border-collapse: collapse;
      background-color: $amber-2;
    }

    th,
    td {
      padding: 10px;
      border: solid 1px;
      text-align: center;
    }
</style>
